import { nanoid } from 'nanoid';
import { signout } from '@features/common';
import {
  $notification,
  $notifications,
  hideNotification,
  notificationUnmounted,
  showErrorNotification,
  showInfoNotification,
  showSuccessNotification,
  showWarningNotification,
} from './notification.model';

$notification
  .on($notifications, (_, payload) =>
    payload.length === 0 ? null : payload[payload.length - 1]
  )
  .reset([notificationUnmounted, signout]);

$notifications
  .on(showSuccessNotification, (state, payload) => [
    ...state,
    { ...payload, id: nanoid(), severity: 'success', variant: 'filled' },
  ])
  .on(showInfoNotification, (state, payload) => [
    ...state,
    { ...payload, id: nanoid(), severity: 'info', variant: 'filled' },
  ])
  .on(showWarningNotification, (state, payload) => [
    ...state,
    { ...payload, id: nanoid(), severity: 'warning', variant: 'filled' },
  ])
  .on(showErrorNotification, (state, payload) => [
    ...state,
    { ...payload, id: nanoid(), severity: 'error', variant: 'filled' },
  ])
  .on(hideNotification, (state, payload) =>
    state.filter((notification) => notification.id !== payload.id)
  )
  .reset([notificationUnmounted, signout]);
